import React from "react"
import Markdown from "react-markdown"
import remarkGfm from "remark-gfm"

import markdown from "/src/assets/markdown/apple-carb-model-more-info.js"

const PILL_CLASSES = {
  Red: "bg-red-100 text-red-800",
  Yellow: "bg-yellow-100 text-yellow-800",
  Green: "bg-green-100 text-green-800",
  Gray: "bg-gray-100 text-gray-600",
  gray: "bg-gray-100 text-gray-600",
}

function ColorPill({ color }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${PILL_CLASSES[color]}`}>
      {color}
    </span>
  )
}

const components = {
  td: ({ children, ...props }) => {
    const text = Array.isArray(children) && children.length === 1 && typeof children[0] === "string"
      ? children[0]
      : null
    return (
      <td {...props}>
        {text && PILL_CLASSES[text] ? <ColorPill color={text} /> : children}
      </td>
    )
  },
}

export default function MoreInfo() {
  return (
    <div className="px-2 mt-4 text-sm prose prose-sm max-w-none">
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {markdown}
      </Markdown>
    </div>
  )
}
